class HBTopSwap extends HTMLElement {
  connectedCallback(){
    if(this.initialized)return;this.initialized=true;
    this.tops=[...this.querySelectorAll('.hb-top')];this.options=[...this.querySelectorAll('.hb-option')];
    this.caption=this.querySelector('[data-caption]');this.count=this.querySelector('[data-count]');this.pause=this.querySelector('.hb-pause');
    if(!this.tops.length)return;
    this.index=0;this.timer=null;this.userPaused=false;this.inView=true;
    this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.userPaused=this.motion.matches;
    this.options.forEach((b,i)=>b.addEventListener('click',()=>{this.userPaused=true;this.show(i,true);this.schedule()}));
    this.pause?.addEventListener('click',()=>{this.userPaused=!this.userPaused;this.schedule()});
    this.onVisibility=()=>this.schedule();document.addEventListener('visibilitychange',this.onVisibility);
    this.onMotion=()=>{if(this.motion.matches)this.userPaused=true;this.schedule()};this.motion.addEventListener('change',this.onMotion);
    this.observer=new IntersectionObserver(([entry])=>{this.inView=entry.isIntersecting;this.schedule()},{threshold:.25});this.observer.observe(this);
    this.show(0);this.schedule();
  }
  show(i,manual=false){
    this.index=i;this.tops.forEach((t,n)=>{t.classList.toggle('is-active',n===i);t.setAttribute('aria-hidden',String(n!==i))});
    this.options.forEach((b,n)=>b.setAttribute('aria-pressed',String(n===i)));
    if(this.caption){this.caption.setAttribute('aria-live',manual?'polite':'off');this.caption.textContent=this.options[i]?.dataset.label||''}
    if(this.count)this.count.textContent=`${String(i+1).padStart(2,'0')} / ${String(this.tops.length).padStart(2,'0')}`;
  }
  schedule(){
    clearInterval(this.timer);this.timer=null;
    const canPlay=!this.userPaused&&!document.hidden&&this.inView&&this.tops.length>1;
    if(canPlay)this.timer=setInterval(()=>this.show((this.index+1)%this.tops.length),4500);
    if(this.pause){this.pause.textContent=this.userPaused?'Play swaps':'Pause swaps';this.pause.setAttribute('aria-pressed',String(this.userPaused));this.pause.setAttribute('aria-label',this.userPaused?'Play automatic top swaps':'Pause automatic top swaps')}
  }
  disconnectedCallback(){clearInterval(this.timer);this.observer?.disconnect();document.removeEventListener('visibilitychange',this.onVisibility);this.motion?.removeEventListener('change',this.onMotion);this.initialized=false}
}
if(!customElements.get('hb-top-swap'))customElements.define('hb-top-swap',HBTopSwap);
